import { ElNotification } from 'element-plus';
import { h } from 'vue';

export function useNotification() {
  const IconMap=(type)=>{
    let customIcon;
    switch (type) {
      case 'success':
        customIcon = h(
          'svg',
          {
            viewBox: '0 0 16 17',
            xmlns: 'http://www.w3.org/2000/svg',
            style: 'width: 20px; height: 20px;fill: #4CAF50;'
          },
          [
            h('path', {
              d: 'M7.99998 1.83325C4.31998 1.83325 1.33331 4.81992 1.33331 8.49992C1.33331 12.1799 4.31998 15.1666 7.99998 15.1666C11.68 15.1666 14.6666 12.1799 14.6666 8.49992C14.6666 4.81992 11.68 1.83325 7.99998 1.83325ZM6.66665 11.8333L3.33331 8.49992L4.27331 7.55992L6.66665 9.94659L11.7266 4.88659L12.6666 5.83325L6.66665 11.8333Z'
            })
          ]
        );
        break;
      case 'error':
        customIcon = h(
          'svg',
          {
            viewBox: '0 0 20 21',
            xmlns: 'http://www.w3.org/2000/svg',
            style: 'width: 20px; height: 20px;fill: #F44336;'
          },
          [
            h('path', {
              d: 'M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z'
            })
          ]
        );
        break;
      default:
        break;
    };

    return customIcon;
  }

  const openNotBottom = (val, type) => {

    ElNotification({
      message: h('div', { style: 'display: flex; align-items: center;', class: `not-icon-${type}` }, [
        IconMap(type),
        h('span', { style: 'margin-left: 8px;' }, val)
      ]),
      position: 'bottom-right',
      duration: 5000
    });
  };

  const openNotEmailBottom = (title, description, btn, type = 'error', customClass='custom-error-notification') => {
    const sendEmail=()=>{
      let email='anchor.support@motom.me';
      window.open(`mailto:${email}`);
    
    };
    
    const icon = IconMap(type);
  
    ElNotification({
      customClass: customClass,
      message: h('div', {
        style: 'display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 420px;'
      }, [
        // 左側 Icon
        icon,
  
        // 中間文字
        h('div', { style: 'flex: 1;' }, [
          h('div', { style: 'font-weight: 600; font-size: 14px; color: #333;' }, title),
          h('div', { style: 'font-size: 13px; color: #666; margin-top: 4px;' }, description)
        ]),
  
        // 右側 Send email 按鈕（帶有事件）
        btn ? h(
          'button',
          {
            style: `
              border: 1px solid #333;
              border-radius: 6px;
              padding: 4px 16px;
              height: 30px;
              font-size: 14px;
              color: #232A60;
              background: #fff;
              cursor: pointer;
              white-space: nowrap;
              font-weight: 500;
            font-family: 'Franklin Gothic Medium';
            `,
            onClick: (e) => {
              e.stopPropagation(); // 防止事件冒泡關閉通知
              sendEmail();
            }
          },
          btn
        ):''
      ]),
      position: 'bottom-right',
      duration: btn ? 10000:5000,
      //duration: 0,
      showClose: true
    });
  };
  return {
    openNotBottom,
    openNotEmailBottom
  };
}
